import { useMutation, useQuery } from '@tanstack/react-query'
import reportApi from 'api/reportApi'
import dayjs from 'dayjs'
import reportHelper from 'features/Report/reportHelper'
import {
  calcMaxCellWidth,
  generateCellObject,
  generateCellStyle,
} from 'general/helpers/ExcelsHelper'
import ToastHelper from 'general/helpers/ToastHelper'
import Utils from 'general/utils/Utils'
import { useAppSelector } from 'hooks/useRedux'
import { get, isNil, isNumber, map, merge, repeat } from 'lodash'
import { utils, writeFile } from 'xlsx-js-style'
import $ from 'jquery'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import { saveAs } from 'file-saver'

const keyFactory = {
  base: { scope: ['report', 'detailInvoiceReport'] },
  lists: (q, f) => [
    {
      ...keyFactory.base,
      params: {
        ...f,
        q,
      },
    },
  ],
  exportExcel: () => [
    {
      ...keyFactory.base,
      action: 'exportExcel',
    },
  ],
}

export function useExportMutation(refetch) {
  return useMutation({
    mutationKey: keyFactory.exportExcel(),
    mutationFn: async (body) => {
      console.log('body:', body) // ✅ Log dữ liệu body
      return await reportApi.exportReportFile(body, {
        typeReport: 'BAOCAOCHITIET',
      })
    },
    onSuccess: () => {
      if (refetch) {
        refetch()
      }
    },
  })
}

export function useGetDetailInvoiceReport(debouncedSearch, filterParams) {
  return useQuery({
    enabled: !isNil(filterParams),
    queryKey: keyFactory.lists(debouncedSearch, filterParams),
    queryFn: ({ signal }) =>
      reportApi.getDetailInvoices(
        {
          ...filterParams,
          q: debouncedSearch,
        },
        signal,
      ),
    select: (res) => {
      return {
        formattedData: get(res, 'data.formattedData', []),
        systemformatNumber: get(res, 'data.systemformatNumber', {}),
        dataInvoiceMultiProduct: get(res, 'data.dataInvoiceMultiProduct', {}),
        rows: get(res, 'data.rows', []),
        total: get(res, 'data.rowsCount', 0),
        fileReport: get(res, 'data.fileReport', {}),
      }
    },
  })
}
